<template>
    <v-container fluid>
        <fulldialog 
            v-if="dialogEditar"
            v-bind:clientesTodos="clientesTodos"
            v-bind:clientesGrupo="clientesGrupo"
            v-bind:clientesAnadir="clientesAnadir"
            v-bind:comerciales="comerciales"
        />
        <h1>Mis grupos</h1>
        <v-card :loading="loading">
            <v-card-title>
                <v-text-field
                    v-model="searchGrupo1"
                    append-icon="mdi-account-search-outline"
                    label="Buscar"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table :headers="headersListarGrupos" :items="separarGrupos('privado')" :search="searchGrupo1">
                <template v-slot:item.acciones="{ item }">
                    <v-icon @click="setGrupo(item), editarGrupo()" class="mr-2">mdi-pencil</v-icon>
                    <v-icon 
                    @click="setGrupo(item), dialogListadoContratos = true, ordenContratosGrupo()" 
                    class="mr-2" 
                    :color="ordenEspecifico(item)">
                        mdi-sort
                    </v-icon>
                    <v-icon @click="setGrupo(item), dialogEliminar = true">mdi-delete</v-icon>
                </template>
            </v-data-table>
        </v-card>
        <br>    
        <h1>Grupos públicos</h1>
        <v-card :loading="loading">
            <v-card-title>
                <v-text-field
                    v-model="searchGrupo2"
                    append-icon="mdi-account-search-outline"
                    label="Buscar"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table :headers="headersListarGrupos" :items="separarGrupos('publico')" :search="searchGrupo2">
                <template v-slot:item.acciones="{ item }">
                    <v-icon @click="setGrupo(item), editarGrupo()" class="mr-2">mdi-pencil</v-icon>
                    <v-icon 
                    @click="setGrupo(item), dialogListadoContratos = true, ordenContratosGrupo()" 
                    class="mr-2"
                    :color="ordenEspecifico(item)">
                        mdi-sort
                    </v-icon>
                    <v-icon @click="setGrupo(item), dialogEliminar = true">mdi-delete</v-icon>
                </template>
            </v-data-table>
        </v-card>
        <!-- CREAR GRUPO -->
        <v-btn fab dark color="teal lighten-1" @click="dialogNuevoGrupo=true; ejecutarFoco()" fixed style="bottom: 37px; right: 30px;">
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-row justify="center">
            <v-dialog v-model="dialogNuevoGrupo" persistent width="500">
                <v-card>
                    <v-card-title class="headline">Nuevo grupo</v-card-title>
                    <v-card-text class="pb-0">
                        <div class="text-h6">
                            <v-text-field 
                                label="Nombre del grupo" 
                                class="mt-2 pb-2" 
                                v-model="nombreGrupo" 
                                hide-details
                                ref="input"
                                autofocus
                            >
                            </v-text-field> 
                            <v-radio-group v-model="tipoGrupo" row>
                                <v-radio label="Grupo Privado" value="0"></v-radio>
                                <v-radio label="Grupo Público" value="1"></v-radio>
                            </v-radio-group>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="finCrearGrupo()">Cancelar</v-btn>
                        <v-btn color="green" text @click="crearGrupo()" :disabled="this.$v.nombreGrupo.$invalid">Crear</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <!-- ELIMINAR -->
        <v-row justify="center">
            <v-dialog v-model="dialogEliminar" persistent width="500">
                <v-card>
                    <v-card-title class="headline">¡Atención!</v-card-title>
                    <v-card-text><div class="text-h6">{{contenidoDialogEliminar()}}</div></v-card-text>
                    <v-checkbox v-if="grupo.publico === 1" class="mt-0 ml-5" v-model="selected" label="Entiendo que al eliminar este grupo, se eliminará para todos los usuarios." value="true"></v-checkbox>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="finDialogEliminar()">Cancelar</v-btn>
                    <v-btn color="error" text @click="eliminar()" :disabled="grupo.publico === 1 && selected === false || selected === null">Eliminar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <!-- ORDEN CONTRATOS -->
        <v-row justify="center">
            <v-dialog v-model="dialogListadoContratos" persistent width="500" >
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Preferencia de contratos para este grupo</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="dialogCerrar=true">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                            <v-simple-table>
                                <template>
                                    <tbody>
                                        <tr v-for="item in contratosOrdenados" :key="item.id">
                                            <td>
                                                <v-icon 
                                                @click="cambiarPosicion(item, 'arriba')" 
                                                class="mr-2" 
                                                color="primary"
                                                :disabled="(posicion(item) === 0)"> <!-- El primer contrato tiene la fiecha para subir deshabilitada -->
                                                    mdi-arrow-up
                                                </v-icon>
                                                <v-icon 
                                                @click="cambiarPosicion(item, 'abajo')" 
                                                color="primary"
                                                :disabled="posicion(item) === contratosOrdenados.length -1"> <!-- El ultimo contrato tiene la fiecha para bajar deshabilitada -->
                                                    mdi-arrow-down
                                                </v-icon>
                                            </td>
                                            <td>{{ item.contrato }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" text @click="eliminarOrdenContratos()">Predeterminado</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="green" text @click="guardarNuevoOrden()">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <v-row justify="center">
            <v-dialog v-model="dialogCerrar" persistent max-width="380">
                <v-card>
                    <v-card-title class="headline">¡Atención!</v-card-title>
                    <v-card-text>Vas a salir sin guardar los cambios. ¿Estás seguro?</v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogCerrar = false">Cancelar</v-btn>
                    <v-btn color="error" text @click="dialogListadoContratos=false, dialogCerrar = false">Salir</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
import FullDialog from './FullDialog';
import { mapState, mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import axios from 'axios';
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
export default {
    name: 'acciones_masivas',
    data: () => ({
        grupos: [],
        headersListarGrupos: [
            {
                text: 'Grupo',
                align: 'start',
                filterable: true,
                sortable: false,
                value: 'nombre'
            },
            {
                text: 'Acciones',
                align: 'right',
                filterable: false,
                sortable: false,
                value: 'acciones'
            }
        ],
        dialogNuevoGrupo: false,
        nombreGrupo: '',
        tipoGrupo: '0',
        loading: false,
        search: '',
        dialogEliminar: false,
        dialogListadoContratos: false,
        selected: false,
        contratos: [],
        searchGrupo1: '',
        searchGrupo2: '',
        contratosOrdenados: [],
        clientesTodos: [],
        clientesGrupo: [],
        clientesAnadir: [], 
        comerciales: [],
        dialogCerrar: false
    }),
    validations: {
      nombreGrupo: { required }
    },
    async created(){
        this.loading = true;
        try{
            let respuesta = await axios.get('/api/contratos');//LISTAR CONTRATOS BDD
            this.contratos = respuesta.data;
            let ptoCerrado = this.contratos.find(c => c.id === 7);
            // if(ptoCerrado) this.contratos.push(this.contratos.splice(this.contratos.indexOf(ptoCerrado), 1)[0]);
            if(ptoCerrado) this.contratos.splice(this.contratos.indexOf(ptoCerrado), 1)[0];
            // console.log(this.contratos);
            
            this.recuperarGrupos();
            
            respuesta = await axios.get('/api/clientes'); //LISTAR CLIENTES BBDD
            this.clientesTodos = respuesta.data;

            respuesta = await axios.get("/api/usuarios?grupo=3"); //LISTAR COMERCIALES BBDD
            this.comerciales = respuesta.data;

            this.loading = false;
        } catch (error) {
            this.loading = false;
            this.setSnackbar({
                tipo: "error",
                mensaje: "Error. No se han podido recuperar los datos",
            });
        }
    },
    methods: {
        ...mapActions('misGrupos', ['setGrupo', 'setDialogEditar']),
        ...mapActions(['setLoading', 'setSnackbar']),
        async recuperarGrupos(){
            try {
                let respuesta = await axios.get('/api/gruposaccionesmasivas'); //RECUPERAR GRUPOS BDD
                this.grupos = respuesta.data; 
                this.grupos.forEach(grupo => {
                    if(grupo.orden_contratos){ //combierto el string que contiene el orden de los contratos en array ('a,x,z,y' -> [a, x, z, y])
                        grupo.orden_contratos = grupo.orden_contratos.split(',').map(Number);
                    }
                }); 
            } catch (error) {
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se han podido recuperar los grupos'
                });
            }   
        },
        ordenContratosGrupo(){
            if(this.grupo.orden_contratos){              
                this.contratosOrdenados = [];
                this.grupo.orden_contratos.forEach(cOrden => {
                    this.contratos.forEach(contrato => {
                        if(cOrden == contrato.id && contrato.id !== 7){ //No mostramos el contrato pto. cerrado
                            this.contratosOrdenados.push(contrato);
                        }
                    });
                });
            }
            else{
                console.log(this.contratos);
                this.contratosOrdenados = Array.from(this.contratos);
            }
        },
        separarGrupos(tipo){
            let grupos = [];
            this.grupos.forEach(grupo => {
                if(grupo.publico === 1 && tipo === 'publico'){
                    grupos.push(grupo);
                }else if (grupo.publico === 0 && tipo === 'privado'){
                    grupos.push(grupo);
                };
            });
            return grupos;
        },
        ordenEspecifico(grupo){
            if(grupo.orden_contratos){
                return 'primary';
            }
        },
        contenidoDialogEliminar(){
            if(this.grupo.publico === 1){
                return 'Este grupo es público! ¿Realmente quieres eliminarlo?';
            }else {
                return '¿Realmente quieres eliminarlo?';
            }
        },
        finDialogEliminar(){
            this.dialogEliminar = false;
            this.selected = false;
        },
        async eliminar(){
            this.setLoading(true);
            try {
                let respuesta = await axios.get(`/api/arditimersGrupos/${this.grupo.id}`);//Miro si el grupo tiene timers adjuntos
                let timersAdjuntos = respuesta.data;
                
                if(timersAdjuntos.length !== 0){
                    this.setSnackbar({
                        tipo: 'warning',
                        mensaje: 'El grupo no se puede eliminar porque tiene timers adjudicados'
                    });
                }else{
                    await axios.delete(`/api/gruposaccionesmasivas/${this.grupo.id}`);
                    this.grupos = this.grupos.filter(g => g !== this.grupo); // grupos = a todos los grupos menos this.grupo
                    this.setSnackbar({
                        tipo: 'success',
                        mensaje: 'Datos eliminados correctamente'
                    });
                }

                this.finDialogEliminar();
                this.setLoading(false);
            } catch (error) {
                this.finDialogEliminar();
                this.setLoading(false);
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se ha podido eliminar el grupo'
                });
            }
        },
        cambiarPosicion(contrato, lugar){
            let posicion = this.posicion(contrato);
            this.contratosOrdenados.splice(posicion, 1); 
            if (lugar == 'arriba'){
                this.contratosOrdenados.splice(posicion-1, 0, contrato);
            }else if (lugar == 'abajo'){
                this.contratosOrdenados.splice(posicion+1, 0, contrato);
            }
        },
        posicion(contrato){
            return this.contratosOrdenados.findIndex(c => c === contrato);
        },
        async eliminarOrdenContratos(){
            this.setLoading(true);
            try {
                this.grupo.orden_contratos = 'null';
                await axios.patch('/api/gruposaccionesmasivas', this.grupo);
                delete this.grupo.orden_contratos
                this.dialogListadoContratos = false;
                this.setLoading(false);
            } catch (error) {
                this.setLoading(false);
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se han podido editar los datos'
                });
            }
        },
        async guardarNuevoOrden(){
            this.setLoading(true);

            let IDcontratosOrden = []
            this.contratosOrdenados.forEach(contrato => {
                IDcontratosOrden.push(contrato.id);
            });
            this.grupo.orden_contratos = IDcontratosOrden;
            let stringOrden = this.grupo.orden_contratos.join(); //combierto el array en string [a, x, z, y] -> 'a,x,z,y'
            if(stringOrden == '1,2,3,4,5,6,8,9,10,7'){
                this.grupo.orden_contratos = 'null';
            }else{
                this.grupo.orden_contratos = String(stringOrden);
            }

            try {
                await axios.patch('/api/gruposaccionesmasivas', this.grupo);
                if(this.grupo.orden_contratos == 'null'){
                    delete this.grupo.orden_contratos;
                }else{
                    this.grupo.orden_contratos = IDcontratosOrden;
                }
                this.dialogListadoContratos = false;
                this.setSnackbar({
                    tipo: 'success',
                    mensaje: 'Datos guardados correctamente'
                });
                this.setLoading(false);
            } catch (error) {
                this.setLoading(false);
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se han podido editar los datos'
                });
            }
        },
        crearGrupo(){
            let grupo =
                {
                    nombre: this.nombreGrupo,
                    publico: this.tipoGrupo
                };
            axios.post('/api/gruposaccionesmasivas', grupo).then(respuesta => {
                this.recuperarGrupos();
                this.finCrearGrupo();
                this.setSnackbar({
                    tipo: 'success',
                    mensaje: 'Grupo creado correctamente'
                });
            }).catch(error => { //AÑADIMOS EL GRUPO A LA BDD
                // console.log(error); 
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se han podido crear el grupo'
                });
            }); 
        },
        finCrearGrupo(){
            this.dialogNuevoGrupo = false;
            this.nombreGrupo = '';
            this.tipoGrupo = '0';
        },
        async editarGrupo(){
            this.setLoading(true);
            try{ 
                let respuesta = await axios.get(`/api/gruposaccionesmasivas/${this.grupo.id}`);//CARGAR CLIENTES CORRESPONDIENTES AL GRUPO
                let relacionClientes = respuesta.data;
                this.clientesGrupo = [];
                this.clientesTodos.forEach(cliente => { //Cojo todos los datos de los cliente del grupo
                    if(relacionClientes.some(c => c.cliente_id === cliente.code)){
                        this.clientesGrupo.push(cliente);
                    }
                });
                this.clientesAnadir = [];
                this.clientesTodos.forEach(cliente => { //eliminamos los clientes ya añadidos al grupo del resto de clientes aún disponibles para añadir
                    if(!this.clientesGrupo.some(c => c.code === cliente.code)){
                        this.clientesAnadir.push(cliente);
                    }
                });

                this.setDialogEditar(true)
                this.setLoading(false);
            } catch (error) {
                this.setLoading(false);
                this.setSnackbar({
                    tipo: "error",
                    mensaje: "Error. No se han podido recuperar los datos",
                });
            }
        }, 
        ejecutarFoco(){
            this.$nextTick(() => {
                this.$refs.input.focus();
            });
        },
    },
    computed: {
        ...mapState('misGrupos', ['grupo', 'dialogEditar']),
    },
    components: {
        'fulldialog': FullDialog
    },
    
}
</script>
<style>
    
</style>